import { toast } from 'react-hot-toast';

function Toast(msg) {
    return (
        toast.error(msg, {
            duration: 3500,
            style: {
                border: '2px solid #AB281B',
                padding: '16px',
                color: '#AF2C1F',
            },
            iconTheme: {
                primary: '#AF2C1F',
                secondary: '#FFFAEE',
            }
        })
    )
}

export default Toast;